import type { FC } from "react";

import { Card, type GridCard, LoadingSpinner } from "widgets";

import RelatedProjectPanel from "./RelatedProjectPanel.js";
import type { RelatedProject, User } from "@/graphql.ts";
import { SelMessage } from "@/messages/SelMessage.tsx";
import { getProjectLabel } from "@/redux/modules/config.ts";

export interface IRelatedProjectsCardProps extends GridCard {
  relatedProjects: RelatedProject[];
  isLoading?: boolean;
  currentUser: User;
}

/**
 * A panel with all projects related to the main object.
 * The list of activities for each project is collapsible.
 *
 * created on 11/11/16
 */

const RelatedProjectsCard: FC<IRelatedProjectsCardProps> = (props) => {
  if (!props.relatedProjects) {
    return null;
  }

  return (
    <Card
      title={`Related ${getProjectLabel(true, true)}`}
      tag={{ label: props.relatedProjects ? String(props.relatedProjects.length) : undefined }}
    >
      {props.isLoading ? (
        <LoadingSpinner />
      ) : props.relatedProjects.length === 0 ? (
        <SelMessage id={"noContent.relatedProjects"} />
      ) : (
        props.relatedProjects.map((relatedProject) => {
          return (
            <RelatedProjectPanel
              key={"rel-prj-" + relatedProject.project.id}
              currentUser={props.currentUser}
              project={relatedProject.project}
              activities={relatedProject.activities}
              collapsed={true}
            />
          );
        })
      )}
    </Card>
  );
};

export default RelatedProjectsCard;
export { RelatedProjectsCard };
